import { Step1Illustration, Step2Illustration, Step3Illustration } from "@/components/landing/StepIllustrations";

export const ruStepIllustrations = [<Step1Illustration key="step-1" />, <Step2Illustration key="step-2" />, <Step3Illustration key="step-3" />];

export const HERO_BADGE_POSITIONS = [
  { icon: "target", color: "yellow" as const, left: -456, top: 120, rotate: -2.17 },
  { icon: "clock-countdown", color: "orange" as const, left: 453, top: 28, rotate: 1.78 },
  { icon: "file-audio", color: "orange" as const, left: 453, top: 108, rotate: -2.38 },
  { icon: "wechat-logo", color: "orange" as const, left: 453, top: 192, rotate: 1.89 },
  { icon: "users-three", color: "yellow" as const, left: -454, top: 38, rotate: 1.43 },
  { icon: "speedometer", color: "yellow" as const, left: -464, top: 207, rotate: 1.75 },
];
